<template>
  <div>
    <div
      v-if="hasQuote"
      key="quote"
      class="flex justify-between px-3 py-2 bg-neutral-50 rounded-md mt-1 h-16 flex items-center justify-center"
    >
      <div class="flex flex-col">
        <div class="text-xl font-medium text-neutral-800">
          {{ $t('app.total') }}
        </div>
        <div class="text-light text-neutral-400 text-sm -mt-1">
          {{ $t('quote.including-taxes-and-fees') }}
        </div>
      </div>
      <div
        v-if="(getSearchPet && hidePriceForSearchPet) || (!getSearchPet && hidePricing)"
        class="flex flex-col"
      >
        <span class="text-neutral-900 text-xl font-semibold leading-none text-right">
          {{ $t('quote.free') }}
        </span>
        <span
          v-if="getUser.organization"
          class="text-neutral-500 text-sm leading-none"
        >
          {{ $t('quote.with-your-plan') }}
        </span>
      </div>
      <div
        v-else
        class="flex flex-col group transition cursor-pointer"
        @click="$emit('show-quote-details')"
        @keydown="$emit('show-quote-details')"
      >
        <div class="text-right text-xl font-bold text-neutral-900 group-hover:text-neutral-600 group-focus:outline-none">
          <vetster-discount slot-class="text-sm font-normal">
            {{
              $n(formatMoneyRounded(convertCurrency(getQuote.total.amount)), {
                style: 'currency',
                currency: getConversionCurrency || getQuote.total.currency,
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
              })
            }}
          </vetster-discount>
        </div>
        <span class="underline text-sm text-ocean-900 group-hover:text-ocean-600 -mt-1 cursor-pointer group-focus:outline-none focus:underline">
          {{ $t('quote.view-details') }}
        </span>
      </div>
    </div>
    <div
      v-else
      key="no-quote"
    >
      <div
        v-if="hasError"
        class="text-center text-red-600 font-light p-3 bg-red-50 rounded-md mt-1 h-16 flex items-center justify-center"
      >
        <fa
          class="fa-fw text-xl mr-1"
          :icon="['fal', 'exclamation-circle']"
        />
        <span class="text-sm">{{ getError }}</span>
      </div>
      <div
        v-else
        class="text-center text-neutral-600 font-bold text-lg p-3 bg-neutral-50 rounded-md mt-1 h-16 flex items-center justify-center"
      >
        {{ $t('quote.choose-an-available-time') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import VetsterDiscount from '@/components/VetsterDiscount';
import { formatMoneyRounded } from '@/helpers/format';
import HasConversionRate from '@/mixins/HasConversionRate';

export default {
  name: 'VetsterQuoteTotal',

  components: { VetsterDiscount },

  mixins: [HasConversionRate],

  computed: {
    ...mapGetters([
      'hidePricing',
      'getUser',
    ]),
    ...mapGetters('search', [
      'hidePriceForSearchPet',
      'getSearchPet',
    ]),
    ...mapGetters('quote', [
      'hasQuote',
      'getQuote',
      'getError',
      'hasError',
    ]),
  },

  methods: {
    formatMoneyRounded,
  },
};
</script>
